<template>
  <span>
    <b-dropdown-item v-for="a in attachments_menu" :key="a.value"
      aria-role="listitem"
      @click="clicked(a.value)"
      >{{ a.text }}</b-dropdown-item>
  </span>
</template>

<script>
import attachments from '@/services/attachments'
export default {
  props: {
    n: Object
  },
  computed: {
    attachments_menu () {
      if (this.n) {
        const cap = (i) => i.charAt(0).toUpperCase() + i.slice(1)
        const a = attachments.parse(this.n)
        if (a.all.length > 0) {
          return a.all
            .map(a => ({
              value: a.index,
              text: cap(a.mediaType.split('/')[0])
            }))
        }
      }
      return []
    }
  },
  methods: {
    clicked (index) {
      const parsed = attachments.parse(this.n)
      window.open(parsed.all[index - 1].url)
    },
  }
}
</script>